import { useState } from 'react';
import axios from 'axios';

export const useJournalEntry = (activeProject) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const createJournalEntry = async (entryData) => {
    if (!activeProject?._id) return false;
    setLoading(true);
    setError(null);
    try {
      await axios.post(`/api/projects/${activeProject._id}/journal-entries`, entryData);
      setLoading(false);
      return true;
    } catch (err) {
      console.error('Create Journal Entry error:', err);
      const msg = err.response?.data?.msg || 'Failed to create journal entry';
      setError(msg);
      setLoading(false);
      return false;
    }
  };

  const updateJournalEntry = async (entryId, entryData) => {
    if (!activeProject?._id) return false;
    setLoading(true);
    setError(null);
    try {
      await axios.put(`/api/projects/${activeProject._id}/journal-entries/${entryId}`, entryData);
      setLoading(false);
      return true;
    } catch (err) {
      console.error('Update Journal Entry error:', err);
      const msg = err.response?.data?.msg || 'Failed to update journal entry';
      setError(msg);
      setLoading(false);
      return false;
    }
  };

  const getJournalEntry = async (entryId) => {
    if (!activeProject?._id) return null;
    setLoading(true);
    try {
      const res = await axios.get(`/api/projects/${activeProject._id}/journal-entries/${entryId}`);
      setLoading(false);
      return res.data;
    } catch (err) {
      console.error('Get Journal Entry error:', err);
      setError('Failed to fetch journal entry details');
      setLoading(false);
      return null;
    }
  };

  const deleteJournalEntry = async (entryId) => {
    if (!activeProject?._id) return false;
    if (!window.confirm('Are you sure you want to delete this journal entry and all associated transactions?')) return false;
    
    setLoading(true);
    try {
      await axios.delete(`/api/projects/${activeProject._id}/journal-entries/${entryId}`);
      setLoading(false);
      return true;
    } catch (err) {
      console.error('Delete Journal Entry error:', err);
      setError('Failed to delete journal entry');
      setLoading(false);
      return false;
    }
  };

  return {
    createJournalEntry,
    updateJournalEntry,
    getJournalEntry,
    deleteJournalEntry,
    loading,
    error,
    setError
  };
};
